import Error500Page from "./Error500Page";

export const Error500PageConfig = {
  routes: [
    {
      path: "/script",
      exact: true,
      component: Error500Page
    }
  ]
};
